interface Props {
	contentType: 'subjectFolder' | 'subjectTag' | 'statusFolder' | 'statusTag' | 'typeFolder' | 'typeTag' | string;
	name: string;
	route: {
		path: string;
	};
}
export const buildTagTree = (data: Props[]): Site.Tags => {
	// Group by type
	const groups = {
		subjectTags: data.filter((x) => x.contentType.includes('subject')),
		statusTags: data.filter((x) => x.contentType.includes('status')),
		typeTags: data.filter((x) => x.contentType.includes('type')),
	};

	const buildGroup = (items: Props[]): (Site.SiteTagFolder | Site.SiteTag)[] => {
		const folders = items.filter((x) => x.contentType.endsWith('Folder'));
		const tags = items.filter((x) => !x.contentType.endsWith('Folder'));

		const getParts = (path: string): string[] => path.split('/').filter(Boolean);

		const root: (Site.SiteTagFolder | Site.SiteTag)[] = [];
		const folderMap = new Map<string, Site.SiteTagFolder>();

		const getOrCreateFolder = (pathParts: string[], folderName: string): Site.SiteTagFolder => {
			const key = pathParts.join('|');

			if (!folderMap.has(key)) {
				const folder: Site.SiteTagFolder = { name: folderName, children: [] };
				folderMap.set(key, folder);

				if (pathParts.length > 1) {
					const parentKey = pathParts.slice(0, -1).join('|');
					const parent = folderMap.get(parentKey);
					if (!parent) root.push(folder);
					if (parent) parent.children.push(folder);
				}

				if (pathParts.length === 1) root.push(folder);
			}
			return folderMap.get(key)!;
		};

		folders.forEach((folder) => {
			const parts = getParts(folder.route.path);
			getOrCreateFolder(parts, folder.name);
		});

		// Insert tags
		tags.forEach((tag) => {
			const parts = getParts(tag.route.path);
			const parentKey = parts.slice(0, -1).join('|');
			const tagItem: Site.SiteTag = { name: tag.name };
			const parent = folderMap.get(parentKey);

			if (!parent) root.push(tagItem);
			if (parent) (parent.children as (Site.SiteTagFolder | Site.SiteTag)[]).push(tagItem);
		});

		// If the outermost item is a single folder, unwrap it
		if (root.length === 1 && 'children' in root[0]) return (root[0] as Site.SiteTagFolder).children;

		return root;
	};

	return {
		subjectTags: buildGroup(groups.subjectTags),
		statusTags: buildGroup(groups.statusTags),
		typeTags: buildGroup(groups.typeTags),
	};
};
